import { actions } from './actions'

const initialState = {
  bibliotecasAvatares: {
    data: [],
    loading: false,
    error: '',
  },
  bibliotecaAvatares: {
    data: null,
    loading: false,
    error: '',
  },
  bibliotecasAvataresModelo: {
    data: [],
    loading: false,
    error: '',
  },
  bibliotecasAvataresSecciones: {
    data: [],
    loading: false,
    error: '',
  },
  bibliotecaAvataresSeccion: {
    data: null,
    loading: false,
    error: '',
  },
  bibliotecasAvataresPaletas: {
    data: [],
    loading: false,
    error: '',
  },
  bibliotecaAvataresPaleta: {
    data: null,
    loading: false,
    error: '',
  },
  bibliotecasAvataresSizes: {
    data: [],
    loading: false,
    error: '',
  },
  bibliotecaAvataresSize: {
    data: null,
    loading: false,
    error: '',
  },
  bibliotecasAvataresClienteResume: {
    data: [],
    loading: false,
    error: '',
  },
  bibliotecasAvataresClienteAdmin: {
    data: [],
    loading: false,
    error: '',
  },
  bibliotecaAvataresGaleria: {
    data: [],
    loading: false,
    error: '',
  },
  bibliotecaAvataresObjeto: {
    data: null,
    loading: false,
    error: '',
  },
  bibliotecaAvataresObjetoVariante: {
    data: null,
    loading: false,
    error: '',
  },
  bibliotecaAvataresObjetoUnico: {
    data: null,
    loading: false,
    error: '',
  },
  bibliotecaAvataresCacheCliente: {
    data: null,
    loading: false,
    error: '',
  },
  bibliotecaAvataresCacheAdmin: {
    data: null,
    loading: false,
    error: '',
  },
  bibliotecaAvataresCacheFamilias: {
    data: null,
    loading: false,
    error: '',
  },
  bibliotecaAvataresCacheProductos: {
    data: null,
    loading: false,
    error: '',
  },
  bibliotecaAvataresCachePaises: {
    data: null,
    loading: false,
    error: '',
  },
  bibliotecaAvataresCacheProvincias: {
    data: null,
    loading: false,
    error: '',
  },
  bibliotecaAvataresGaleriaMasivo: {
    data: null,
    loading: false,
    error: '',
  },
  bibliotecasAvataresPlantillas: {
    data: [],
    loading: false,
    error: '',
  },
  bibliotecaAvataresPlantilla: {
    data: null,
    loading: false,
    error: '',
  },
  bibliotecasAvataresPlantillaObjetos: {
    data: [],
    loading: false,
    error: '',
  },
  bibliotecaAvataresPlantillaObjeto: {
    data: null,
    loading: false,
    error: '',
  },
  bibliotecasAvataresLayers: {
    data: [],
    loading: false,
    error: '',
  },
  bibliotecaAvataresLayer: {
    data: null,
    loading: false,
    error: '',
  },
  bibliotecasAvataresColores: {
    data: [],
    loading: false,
    error: '',
  },
  bibliotecaAvataresColor: {
    data: null,
    loading: false,
    error: '',
  },
  bibliotecasAvataresProd: {
    data: [],
    loading: false,
    error: '',
  },
  bibliotecasAvataresPiezas: {
    data: [],
    loading: false,
    error: '',
  },
  bibliotecaAvataresPieza: {
    data: null,
    loading: false,
    error: '',
  },
}

export default function bibAvataresReducer(state = initialState, action) {
  switch (action.type) {
    // Biblioteca de avatares
    case actions.BIBAVATARES_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasAvatares: { ...state.bibliotecasAvatares, data: null, loading: true },
      }
    case actions.BIBAVATARES_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvatares: {
          ...state.bibliotecasAvatares,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_LOAD_FAILED:
      return {
        ...state,
        bibliotecasAvatares: { ...state.bibliotecasAvatares, loading: false, error: action.error },
      }
    case actions.BIBAVATARES_BYID_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecaAvatares: { ...state.bibliotecaAvatares, data: null, loading: true },
      }
    case actions.BIBAVATARES_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvatares: {
          ...state.bibliotecaAvatares,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_BYID_LOAD_FAILED:
      return {
        ...state,
        bibliotecaAvatares: { ...state.bibliotecaAvatares, loading: false, error: action.error },
      }
    case actions.BIBAVATARES_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecaAvatares: { ...state.bibliotecaAvatares, loading: true, error: '' },
      }
    case actions.BIBAVATARES_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvatares: {
          ...state.bibliotecaAvatares,
          data: {
            ...action.payload,
          },
          loading: false,
          error: '',
        },
      }
    case actions.BIBAVATARES_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaAvatares: { ...state.bibliotecaAvatares, loading: false, error: action.error },
      }
    case actions.DELETE_BIBAVATARES_REQUESTED:
      return {
        ...state,
        bibliotecasAvatares: { ...state.bibliotecasAvatares, data: null, loading: true },
      }
    case actions.DELETE_BIBAVATARES_SUCCEEDED: {
      return {
        ...state,
        bibliotecasAvatares: {
          ...state.bibliotecasAvatares,
          data: state.bibliotecasAvatares.data.filter(d => action.payload !== d.id),
          loading: false,
          reload: false,
        },
      }
    }
    case actions.DELETE_BIBAVATARES_FAILED:
      return {
        ...state,
        bibliotecasAvatares: { ...state.bibliotecasAvatares, loading: false, error: action.error },
      }
    // Modelo
    case actions.BIBAVATARES_MODELO_BYID_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresModelo: {
          ...state.bibliotecaAvataresModelo,
          data: null,
          loading: true,
        },
      }
    case actions.BIBAVATARES_MODELO_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresModelo: {
          ...state.bibliotecaAvataresModelo,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_MODELO_BYID_LOAD_FAILED:
      return {
        ...state,
        bibliotecaAvataresModelo: {
          ...state.bibliotecaAvataresModelo,
          loading: false,
          error: action.error,
        },
      }
    // Secciones
    case actions.BIBAVATARES_SECCION_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasAvataresSecciones: {
          ...state.bibliotecasAvataresSecciones,
          data: null,
          loading: true,
        },
      }
    case actions.BIBAVATARES_SECCION_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresSecciones: {
          ...state.bibliotecasAvataresSecciones,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_SECCION_LOAD_FAILED:
      return {
        ...state,
        bibliotecasAvataresSecciones: {
          ...state.bibliotecasAvataresSecciones,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_SECCION_BYID_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresSeccion: {
          ...state.bibliotecaAvataresSeccion,
          data: null,
          loading: true,
        },
      }
    case actions.BIBAVATARES_SECCION_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresSeccion: {
          ...state.bibliotecaAvataresSeccion,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_SECCION_BYID_LOAD_FAILED:
      return {
        ...state,
        bibliotecaAvataresSeccion: {
          ...state.bibliotecaAvataresSeccion,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_SECCION_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresSeccion: { ...state.bibliotecaAvataresSeccion, loading: true, error: '' },
      }
    case actions.BIBAVATARES_SECCION_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresSeccion: {
          ...state.bibliotecaAvataresSeccion,
          data: {
            ...action.payload,
          },
          loading: false,
          error: '',
        },
      }
    case actions.BIBAVATARES_SECCION_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaAvataresSeccion: {
          ...state.bibliotecaAvataresSeccion,
          loading: false,
          error: action.error,
        },
      }
    case actions.DELETE_BIBAVATARES_SECCION_REQUESTED:
      return {
        ...state,
        bibliotecasAvataresSecciones: {
          ...state.bibliotecasAvataresSecciones,
          data: null,
          loading: true,
        },
      }
    case actions.DELETE_BIBAVATARES_SECCION_SUCCEEDED: {
      return {
        ...state,
        bibliotecasAvataresSecciones: {
          ...state.bibliotecasAvataresSecciones,
          data: state.bibliotecasAvataresSecciones.data.filter(d => action.payload !== d.id),
          loading: false,
          reload: false,
        },
      }
    }
    case actions.DELETE_BIBAVATARES_SECCION_FAILED:
      return {
        ...state,
        bibliotecasAvataresSecciones: {
          ...state.bibliotecasAvataresSecciones,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_SECCION_UPDATE_ORDER_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresSecciones: {
          data: state.bibliotecaAvataresSecciones,
          loading: true,
          error: '',
        },
      }
    case actions.BIBAVATARES_SECCION_UPDATE_ORDER_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresSecciones: {
          data: state.bibliotecaAvataresSecciones,
          loading: false,
          error: '',
        },
      }
    case actions.BIBAVATARES_SECCION_UPDATE_ORDER_FAILED:
      return {
        ...state,
        bibliotecaAvataresSecciones: {
          ...state.bibliotecaAvataresSecciones,
          loading: false,
          error: action.error,
        },
      }
    // Paletas
    case actions.BIBAVATARES_PALETA_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasAvataresPaletas: {
          ...state.bibliotecasAvataresPaletas,
          data: null,
          loading: true,
        },
      }
    case actions.BIBAVATARES_PALETA_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresPaletas: {
          ...state.bibliotecasAvataresPaletas,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_PALETA_LOAD_FAILED:
      return {
        ...state,
        bibliotecasAvataresPaletas: {
          ...state.bibliotecasAvataresPaletas,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_PALETA_BYID_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresPaleta: { ...state.bibliotecaAvataresPaleta, data: null, loading: true },
      }
    case actions.BIBAVATARES_PALETA_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresPaleta: {
          ...state.bibliotecaAvataresPaleta,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_PALETA_BYID_LOAD_FAILED:
      return {
        ...state,
        bibliotecaAvataresPaleta: {
          ...state.bibliotecaAvataresPaleta,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_PALETA_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresPaleta: { ...state.bibliotecaAvataresPaleta, loading: true, error: '' },
      }
    case actions.BIBAVATARES_PALETA_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresPaletas: {
          ...state.bibliotecasAvataresPaletas,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_PALETA_INSERT_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresPaletas: {
          ...state.bibliotecasAvataresPaletas,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_PALETA_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaAvataresPaleta: {
          ...state.bibliotecaAvataresPaleta,
          loading: false,
          error: action.error,
        },
      }
    case actions.DELETE_BIBAVATARES_PALETA_REQUESTED:
      return {
        ...state,
        bibliotecasAvataresPaletas: { ...state.bibliotecasAvataresPaletas, loading: true },
      }
    case actions.DELETE_BIBAVATARES_PALETA_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresPaletas: {
          ...state.bibliotecasAvataresPaletas,
          loading: false,
          data: state.bibliotecasAvataresPaletas.data.filter(size => size.id !== action.payload),
        },
      }
    case actions.DELETE_BIBAVATARES_PALETA_FAILED:
      return {
        ...state,
        bibliotecasAvataresPaletas: {
          ...state.bibliotecasAvataresPaletas,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_PALETA_DUPLICAR_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresPaleta: { ...state.bibliotecaAvataresPaleta, loading: true, error: '' },
      }
    case actions.BIBAVATARES_PALETA_DUPLICAR_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresPaleta: {
          ...state.bibliotecaAvataresPaleta,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_PALETA_DUPLICAR_FAILED:
      return {
        ...state,
        bibliotecaAvataresPaleta: {
          ...state.bibliotecaAvataresPaleta,
          loading: false,
          error: action.error,
        },
      }
    // Tamaños
    case actions.BIBAVATARES_SIZE_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasAvataresSizes: { ...state.bibliotecasAvataresSizes, data: null, loading: true },
      }
    case actions.BIBAVATARES_SIZEFAM_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasAvataresSizes: { ...state.bibliotecasAvataresSizes, data: null, loading: true },
      }
    case actions.BIBAVATARES_SIZE_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresSizes: {
          ...state.bibliotecasAvataresSizes,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_SIZE_LOAD_FAILED:
      return {
        ...state,
        bibliotecasAvataresSizes: {
          ...state.bibliotecasAvataresSizes,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_SIZE_BYID_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresSize: { ...state.bibliotecaAvataresSize, data: null, loading: true },
      }
    case actions.BIBAVATARES_SIZE_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresSize: {
          ...state.bibliotecaAvataresSize,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_SIZE_BYID_LOAD_FAILED:
      return {
        ...state,
        bibliotecaAvataresSize: {
          ...state.bibliotecaAvataresSize,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_SIZE_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresSize: { ...state.bibliotecaAvataresSize, loading: true, error: '' },
      }
    case actions.BIBAVATARES_SIZE_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresSizes: {
          ...state.bibliotecasAvataresSizes,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_SIZE_INSERT_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresSizes: {
          ...state.bibliotecasAvataresSizes,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_SIZE_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaAvataresSize: {
          ...state.bibliotecaAvataresSize,
          loading: false,
          error: action.error,
        },
      }
    case actions.DELETE_BIBAVATARES_SIZE_REQUESTED:
      return {
        ...state,
        bibliotecasAvataresSizes: { ...state.bibliotecasAvataresSizes, loading: true },
      }
    case actions.DELETE_BIBAVATARES_SIZE_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresSizes: {
          ...state.bibliotecasAvataresSizes,
          loading: false,
          data: state.bibliotecasAvataresSizes.data.filter(size => size.id !== action.payload),
        },
      }
    case actions.DELETE_BIBAVATARES_SIZE_FAILED:
      return {
        ...state,
        bibliotecasAvataresSizes: {
          ...state.bibliotecasAvataresSizes,
          loading: false,
          error: action.error,
        },
      }
    // Avatares de cliente
    case actions.BIBAVATARES_CLIENTE_RESUME_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasAvataresClienteResume: {
          ...state.bibliotecasAvataresClienteResume,
          data: null,
          loading: true,
        },
      }
    case actions.BIBAVATARES_CLIENTE_RESUME_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresClienteResume: {
          ...state.bibliotecasAvataresClienteResume,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_CLIENTE_RESUME_LOAD_FAILED:
      return {
        ...state,
        bibliotecasAvataresClienteResume: {
          ...state.bibliotecasAvataresClienteResume,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_CLIENTE_ADMIN_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasAvataresClienteAdmin: {
          ...state.bibliotecasAvataresClienteAdmin,
          data: null,
          loading: true,
        },
      }
    case actions.BIBAVATARES_CLIENTE_ADMIN_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresClienteAdmin: {
          ...state.bibliotecasAvataresClienteAdmin,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_CLIENTE_ADMIN_LOAD_FAILED:
      return {
        ...state,
        bibliotecasAvataresClienteAdmin: {
          ...state.bibliotecasAvataresClienteAdmin,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_CLIENTE_EMAIL_ADMIN_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasAvataresClienteAdmin: {
          ...state.bibliotecasAvataresClienteAdmin,
          data: null,
          loading: true,
        },
      }
    case actions.BIBAVATARES_CLIENTE_EMAIL_ADMIN_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresClienteAdmin: {
          ...state.bibliotecasAvataresClienteAdmin,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_CLIENTE_EMAIL_ADMIN_LOAD_FAILED:
      return {
        ...state,
        bibliotecasAvataresClienteAdmin: {
          ...state.bibliotecasAvataresClienteAdmin,
          loading: false,
          error: action.error,
        },
      }
    // Galería de familia de avatares
    case actions.BIBAVATARES_GALERIA_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresGaleria: {
          ...state.bibliotecaAvataresGaleria,
          data: null,
          loading: true,
        },
      }
    case actions.BIBAVATARES_GALERIA_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresGaleria: {
          ...state.bibliotecaAvataresGaleria,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_GALERIA_LOAD_FAILED:
      return {
        ...state,
        bibliotecaAvataresGaleria: {
          ...state.bibliotecaAvataresGaleria,
          loading: false,
          error: action.error,
        },
      }
    // Objetos
    case actions.BIBAVATARES_OBJETO_BYID_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresObjeto: { ...state.bibliotecaAvataresObjeto, data: null, loading: true },
      }
    case actions.BIBAVATARES_OBJETO_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_OBJETO_BYID_LOAD_FAILED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_OBJETO_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          loading: true,
          error: '',
        },
      }
    case actions.BIBAVATARES_OBJETO_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          data: {
            ...action.payload,
          },
          loading: false,
          error: '',
        },
      }
    case actions.BIBAVATARES_OBJETO_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_OBJETO_INSERT_MINIATURA_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          loading: true,
          error: '',
        },
      }
    case actions.BIBAVATARES_OBJETO_INSERT_MINIATURA_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          data: {
            ...action.payload,
          },
          loading: false,
          error: '',
        },
      }
    case actions.BIBAVATARES_OBJETO_INSERT_MINIATURA_FAILED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_OBJETO_DELETE_MINIATURA_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          loading: true,
          error: '',
        },
      }
    case actions.BIBAVATARES_OBJETO_DELETE_MINIATURA_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          data: {
            ...action.payload,
          },
          loading: false,
          error: '',
        },
      }
    case actions.BIBAVATARES_OBJETO_DELETE_MINIATURA_FAILED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_OBJETO_INSERT_IMPRESION_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          loading: true,
          error: '',
        },
      }
    case actions.BIBAVATARES_OBJETO_INSERT_IMPRESION_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          data: {
            ...action.payload,
          },
          loading: false,
          error: '',
        },
      }
    case actions.BIBAVATARES_OBJETO_INSERT_IMPRESION_FAILED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_OBJETO_DELETE_IMPRESION_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          loading: true,
          error: '',
        },
      }
    case actions.BIBAVATARES_OBJETO_DELETE_IMPRESION_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          data: {
            ...action.payload,
          },
          loading: false,
          error: '',
        },
      }
    case actions.BIBAVATARES_OBJETO_DELETE_IMPRESION_FAILED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_OBJETO_VARIANTE_SIZE_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          loading: true,
          error: '',
        },
      }
    case actions.BIBAVATARES_OBJETO_VARIANTE_SIZE_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          data: {
            ...action.payload,
          },
          loading: false,
          error: '',
        },
      }
    case actions.BIBAVATARES_OBJETO_VARIANTE_SIZE_FAILED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_OBJETO_DELETE_VARIANTE_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          loading: true,
          error: '',
        },
      }
    case actions.BIBAVATARES_OBJETO_DELETE_VARIANTE_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          data: {
            ...action.payload,
          },
          loading: false,
          error: '',
        },
      }
    case actions.BIBAVATARES_OBJETO_DELETE_VARIANTE_FAILED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          loading: false,
          error: action.error,
        },
      }
    // Objeto unico
    case actions.BIBAVATARES_OBJETO_UNICO_BYID_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresObjetoUnico: {
          ...state.bibliotecaAvataresObjetoUnico,
          data: null,
          loading: true,
        },
      }
    case actions.BIBAVATARES_OBJETO_UNICO_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresObjetoUnico: {
          ...state.bibliotecaAvataresObjetoUnico,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_OBJETO_UNICO_BYID_LOAD_FAILED:
      return {
        ...state,
        bibliotecaAvataresObjetoUnico: {
          ...state.bibliotecaAvataresObjetoUnico,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_OBJETO_UNICO_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          data: null,
          loading: true,
        },
      }
    case actions.BIBAVATARES_OBJETO_UNICO_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_OBJETO_UNICO_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          loading: false,
          error: action.error,
        },
      }
    // Objeto variante
    case actions.BIBAVATARES_OBJETO_VARIANTE_BYID_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresObjetoVariante: {
          ...state.bibliotecaAvataresObjetoVariante,
          data: null,
          loading: true,
        },
      }
    case actions.BIBAVATARES_OBJETO_VARIANTE_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresObjetoVariante: {
          ...state.bibliotecaAvataresObjetoVariante,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_OBJETO_VARIANTE_BYID_LOAD_FAILED:
      return {
        ...state,
        bibliotecaAvataresObjetoVariante: {
          ...state.bibliotecaAvataresObjetoVariante,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_OBJETO_VARIANTE_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresObjetoVariante: {
          ...state.bibliotecaAvataresObjetoVariante,
          loading: true,
          error: '',
        },
      }
    case actions.BIBAVATARES_OBJETO_VARIANTE_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresObjetoVariante: {
          ...state.bibliotecaAvataresObjetoVariante,
          data: {
            ...action.payload,
          },
          loading: false,
          error: '',
        },
      }
    case actions.BIBAVATARES_OBJETO_VARIANTE_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaAvataresObjetoVariante: {
          ...state.bibliotecaAvataresObjetoVariante,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_OBJETO_INSERT_VARIANTE_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          loading: true,
          error: '',
        },
      }
    case actions.BIBAVATARES_OBJETO_INSERT_VARIANTE_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          data: {
            ...action.payload,
          },
          loading: false,
          error: '',
        },
      }
    case actions.BIBAVATARES_OBJETO_INSERT_VARIANTE_FAILED:
      return {
        ...state,
        bibliotecaAvataresObjeto: {
          ...state.bibliotecaAvataresObjeto,
          loading: false,
          error: action.error,
        },
      }
    // Cache cliente/admin
    case actions.BIBAVATARES_CACHE_CLIENTE_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresCacheCliente: {
          ...state.bibliotecaAvataresCacheCliente,
          loading: true,
          error: '',
        },
      }
    case actions.BIBAVATARES_CACHE_CLIENTE_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresCacheCliente: {
          ...state.bibliotecaAvataresCacheCliente,
          loading: false,
          error: '',
        },
      }
    case actions.BIBAVATARES_CACHE_CLIENTE_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaAvataresCacheCliente: {
          ...state.bibliotecaAvataresCacheCliente,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_CACHE_ADMIN_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresCacheAdmin: {
          ...state.bibliotecaAvataresCacheAdmin,
          loading: true,
          error: '',
        },
      }
    case actions.BIBAVATARES_CACHE_ADMIN_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresCacheAdmin: {
          ...state.bibliotecaAvataresCacheAdmin,
          loading: false,
          error: '',
        },
      }
    case actions.BIBAVATARES_CACHE_ADMIN_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaAvataresCacheAdmin: {
          ...state.bibliotecaAvataresCacheAdmin,
          loading: false,
          error: action.error,
        },
      }
    // Otras caches
    case actions.BIBAVATARES_CACHE_FAMILIAS_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresCacheFamilias: {
          ...state.bibliotecaAvataresCacheFamilias,
          loading: true,
          error: '',
        },
      }
    case actions.BIBAVATARES_CACHE_FAMILIAS_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresCacheFamilias: {
          ...state.bibliotecaAvataresCacheFamilias,
          loading: false,
          error: '',
        },
      }
    case actions.BIBAVATARES_CACHE_FAMILIAS_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaAvataresCacheFamilias: {
          ...state.bibliotecaAvataresCacheFamilias,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_CACHE_PRODUCTOS_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresCacheProductos: {
          ...state.bibliotecaAvataresCacheProductos,
          loading: true,
          error: '',
        },
      }
    case actions.BIBAVATARES_CACHE_PRODUCTOS_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresCacheProductos: {
          ...state.bibliotecaAvataresCacheProductos,
          loading: false,
          error: '',
        },
      }
    case actions.BIBAVATARES_CACHE_PRODUCTOS_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaAvataresCacheProductos: {
          ...state.bibliotecaAvataresCacheProductos,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_CACHE_PAISES_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresCachePaises: {
          ...state.bibliotecaAvataresCachePaises,
          loading: true,
          error: '',
        },
      }
    case actions.BIBAVATARES_CACHE_PAISES_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresCachePaises: {
          ...state.bibliotecaAvataresCachePaises,
          loading: false,
          error: '',
        },
      }
    case actions.BIBAVATARES_CACHE_PAISES_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaAvataresCachePaises: {
          ...state.bibliotecaAvataresCachePaises,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_CACHE_PROVINCIAS_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresCacheProvincias: {
          ...state.bibliotecaAvataresCacheProvincias,
          loading: true,
          error: '',
        },
      }
    case actions.BIBAVATARES_CACHE_PROVINCIAS_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresCacheProvincias: {
          ...state.bibliotecaAvataresCacheProvincias,
          loading: false,
          error: '',
        },
      }
    case actions.BIBAVATARES_CACHE_PROVINCIAS_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaAvataresCacheProvincias: {
          ...state.bibliotecaAvataresCacheProvincias,
          loading: false,
          error: action.error,
        },
      }
    // Galeria -> Carga masiva
    case actions.BIBAVATARES_GALERIA_MASIVO_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresGaleriaMasivo: {
          ...state.bibliotecaAvataresGaleriaMasivo,
          data: null,
          loading: true,
        },
      }
    case actions.BIBAVATARES_GALERIA_MASIVO_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresGaleriaMasivo: {
          ...state.bibliotecaAvataresGaleriaMasivo,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_GALERIA_MASIVO_FAILED:
      return {
        ...state,
        bibliotecaAvataresGaleriaMasivo: {
          ...state.bibliotecaAvataresGaleriaMasivo,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_GALERIA_CONFIRM_MASIVO_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresGaleriaMasivo: {
          ...state.bibliotecaAvataresGaleriaMasivo,
          data: null,
          loading: true,
        },
      }
    case actions.BIBAVATARES_GALERIA_CONFIRM_MASIVO_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresGaleriaMasivo: {
          ...state.bibliotecaAvataresGaleriaMasivo,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_GALERIA_CONFIRM_MASIVO_FAILED:
      return {
        ...state,
        bibliotecaAvataresGaleriaMasivo: {
          ...state.bibliotecaAvataresGaleriaMasivo,
          loading: false,
          error: action.error,
        },
      }
    // Galeria -> Carga de fichero
    case actions.BIBAVATARES_GALERIA_UPLOAD_IMAGE_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresGaleria: {
          ...state.bibliotecaAvataresGaleria,
          data: null,
          loading: true,
        },
      }
    case actions.BIBAVATARES_GALERIA_UPLOAD_IMAGE_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresGaleria: {
          ...state.bibliotecaAvataresGaleria,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_GALERIA_UPLOAD_IMAGE_FAILED:
      return {
        ...state,
        bibliotecaAvataresGaleria: {
          ...state.bibliotecaAvataresGaleria,
          loading: false,
          error: action.error,
        },
      }
    // Plantillas
    case actions.BIBAVATARES_PLANTILLA_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasAvataresPlantillas: {
          ...state.bibliotecasAvataresPlantillas,
          data: null,
          loading: true,
        },
      }
    case actions.BIBAVATARES_PLANTILLA_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresPlantillas: {
          ...state.bibliotecasAvataresPlantillas,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_PLANTILLA_LOAD_FAILED:
      return {
        ...state,
        bibliotecasAvataresPlantillas: {
          ...state.bibliotecasAvataresPlantillas,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_PLANTILLA_BYID_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresPlantilla: {
          ...state.bibliotecaAvataresPlantilla,
          data: null,
          loading: true,
        },
      }
    case actions.BIBAVATARES_PLANTILLA_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresPlantilla: {
          ...state.bibliotecaAvataresPlantilla,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_PLANTILLA_BYID_LOAD_FAILED:
      return {
        ...state,
        bibliotecaAvataresPlantilla: {
          ...state.bibliotecaAvataresPlantilla,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_PLANTILLA_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresPlantilla: {
          ...state.bibliotecaAvataresPlantilla,
          loading: true,
          error: '',
        },
      }
    case actions.BIBAVATARES_PLANTILLA_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresPlantilla: {
          ...state.bibliotecaAvataresPlantilla,
          data: {
            ...action.payload,
          },
          loading: false,
          error: '',
        },
      }
    case actions.BIBAVATARES_PLANTILLA_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaAvataresPlantilla: {
          ...state.bibliotecaAvataresPlantilla,
          loading: false,
          error: action.error,
        },
      }
    case actions.DELETE_BIBAVATARES_PLANTILLA_REQUESTED:
      return {
        ...state,
        bibliotecasAvataresPlantillas: {
          ...state.bibliotecasAvataresPlantillas,
          data: null,
          loading: true,
        },
      }
    case actions.DELETE_BIBAVATARES_PLANTILLA_SUCCEEDED: {
      return {
        ...state,
        bibliotecasAvataresPlantillas: {
          ...state.bibliotecasAvataresPlantillas,
          data: state.bibliotecasAvataresPlantillas.data.filter(d => action.payload !== d.id),
          loading: false,
          reload: false,
        },
      }
    }
    case actions.DELETE_BIBAVATARES_PLANTILLA_FAILED:
      return {
        ...state,
        bibliotecasAvataresPlantillas: {
          ...state.bibliotecasAvataresPlantillas,
          loading: false,
          error: action.error,
        },
      }
    // Objetos de plantilla
    case actions.BIBAVATARES_PLANTILLA_OBJETOS_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasAvataresPlantillaObjetos: {
          ...state.bibliotecasAvataresPlantillaObjetos,
          data: null,
          loading: true,
        },
      }
    case actions.BIBAVATARES_PLANTILLA_OBJETOS_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresPlantillaObjetos: {
          ...state.bibliotecasAvataresPlantillaObjetos,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_PLANTILLA_OBJETOS_LOAD_FAILED:
      return {
        ...state,
        bibliotecasAvataresPlantillaObjetos: {
          ...state.bibliotecasAvataresPlantillaObjetos,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_PLANTILLA_OBJETO_BYID_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresPlantillaObjeto: {
          ...state.bibliotecaAvataresPlantillaObjeto,
          data: null,
          loading: true,
        },
      }
    case actions.BIBAVATARES_PLANTILLA_OBJETO_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecaAvataresPlantillaObjeto: {
          ...state.bibliotecaAvataresPlantillaObjeto,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_PLANTILLA_OBJETO_BYID_LOAD_FAILED:
      return {
        ...state,
        bibliotecaAvataresPlantillaObjeto: {
          ...state.bibliotecaAvataresPlantillaObjeto,
          loading: false,
          error: action.error,
        },
      }
    // Layers
    case actions.BIBAVATARES_LAYER_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasAvataresLayers: {
          ...state.bibliotecasAvataresLayers,
          data: null,
          loading: true,
        },
      }
    case actions.BIBAVATARES_LAYER_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresLayers: {
          ...state.bibliotecasAvataresLayers,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_LAYER_LOAD_FAILED:
      return {
        ...state,
        bibliotecasAvataresLayers: {
          ...state.bibliotecasAvataresLayers,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_LAYER_BYID_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresLayer: { ...state.bibliotecaAvataresLayer, data: null, loading: true },
      }
    case actions.BIBAVATARES_LAYER_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresLayers: {
          ...state.bibliotecasAvataresLayers,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_LAYER_BYID_LOAD_FAILED:
      return {
        ...state,
        bibliotecaAvataresLayer: {
          ...state.bibliotecaAvataresLayer,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_LAYER_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresLayers: {
          ...state.bibliotecasAvataresLayers,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_LAYER_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresLayer: { ...state.bibliotecaAvataresLayer, loading: true, error: '' },
      }
    case actions.BIBAVATARES_LAYER_INSERT_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresLayers: {
          ...state.bibliotecasAvataresLayers,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_LAYER_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaAvataresLayer: {
          ...state.bibliotecaAvataresLayer,
          loading: false,
          error: action.error,
        },
      }
    case actions.DELETE_BIBAVATARES_LAYER_REQUESTED:
      return {
        ...state,
        bibliotecasAvataresLayers: { ...state.bibliotecasAvataresLayers, loading: true },
      }
    case actions.DELETE_BIBAVATARES_LAYER_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresLayers: {
          ...state.bibliotecasAvataresLayers,
          loading: false,
          data: state.bibliotecasAvataresLayers.data.filter(size => size.id !== action.payload),
        },
      }
    case actions.DELETE_BIBAVATARES_LAYER_FAILED:
      return {
        ...state,
        bibliotecasAvataresLayers: {
          ...state.bibliotecasAvataresLayers,
          loading: false,
          error: action.error,
        },
      }
    // Color
    case actions.BIBAVATARES_COLOR_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasAvataresColores: {
          ...state.bibliotecasAvataresColores,
          data: null,
          loading: true,
        },
      }
    case actions.BIBAVATARES_COLOR_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresColores: {
          ...state.bibliotecasAvataresColores,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_COLOR_LOAD_FAILED:
      return {
        ...state,
        bibliotecasAvataresColores: {
          ...state.bibliotecasAvataresColores,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_COLOR_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresColores: {
          ...state.bibliotecasAvataresColores,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_COLOR_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecasAvataresColores: {
          ...state.bibliotecasAvataresColores,
          loading: true,
          error: '',
        },
      }
    case actions.BIBAVATARES_COLOR_INSERT_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresColores: {
          ...state.bibliotecasAvataresColores,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_COLOR_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaAvataresColor: {
          ...state.bibliotecaAvataresColor,
          loading: false,
          error: action.error,
        },
      }
    case actions.DELETE_BIBAVATARES_COLOR_REQUESTED:
      return {
        ...state,
        bibliotecasAvataresColores: { ...state.bibliotecasAvataresColores, loading: true },
      }
    case actions.DELETE_BIBAVATARES_COLOR_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresColores: {
          ...state.bibliotecasAvataresColores,
          loading: false,
          data: state.bibliotecasAvataresColores.data.filter(size => size.id !== action.payload),
        },
      }
    case actions.DELETE_BIBAVATARES_COLOR_FAILED:
      return {
        ...state,
        bibliotecasAvataresColores: {
          ...state.bibliotecasAvataresColores,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_COLOR_UPDATE_ORDER_REQUESTED:
      return {
        ...state,
        bibliotecasAvataresColores: {
          data: state.bibliotecasAvataresColores,
          loading: true,
          error: '',
        },
      }
    case actions.BIBAVATARES_COLOR_UPDATE_ORDER_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresColores: {
          ...state.bibliotecasAvataresColores,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_COLOR_UPDATE_ORDER_FAILED:
      return {
        ...state,
        bibliotecasAvataresColores: {
          ...state.bibliotecasAvataresColores,
          loading: false,
          error: action.error,
        },
      }
    // Avatares por producto
    case actions.BIBAVATARES_PROD_BYID_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasAvataresProd: { ...state.bibliotecasAvataresProd, data: null, loading: true },
      }
    case actions.BIBAVATARES_PROD_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresProd: {
          ...state.bibliotecasAvataresProd,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_PROD_BYID_LOAD_FAILED:
      return {
        ...state,
        bibliotecasAvataresProd: {
          ...state.bibliotecasAvataresProd,
          loading: false,
          error: action.error,
        },
      }
    // Piezas
    case actions.BIBAVATARES_PIEZA_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasAvataresPiezas: {
          ...state.bibliotecasAvataresPiezas,
          data: null,
          loading: true,
        },
      }
    case actions.BIBAVATARES_PIEZA_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresPiezas: {
          ...state.bibliotecasAvataresPiezas,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_PIEZA_LOAD_FAILED:
      return {
        ...state,
        bibliotecasAvataresPiezas: {
          ...state.bibliotecasAvataresPiezas,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_PIEZA_BYID_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresPieza: { ...state.bibliotecaAvataresPieza, data: null, loading: true },
      }
    case actions.BIBAVATARES_PIEZA_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresPiezas: {
          ...state.bibliotecasAvataresPiezas,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_PIEZA_BYID_LOAD_FAILED:
      return {
        ...state,
        bibliotecaAvataresPieza: {
          ...state.bibliotecaAvataresPieza,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBAVATARES_PIEZA_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresPiezas: {
          ...state.bibliotecasAvataresPiezas,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_PIEZA_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecaAvataresPieza: { ...state.bibliotecaAvataresPieza, loading: true, error: '' },
      }
    case actions.BIBAVATARES_PIEZA_INSERT_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresPiezas: {
          ...state.bibliotecasAvataresPiezas,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBAVATARES_PIEZA_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaAvataresPieza: {
          ...state.bibliotecaAvataresPieza,
          loading: false,
          error: action.error,
        },
      }
    case actions.DELETE_BIBAVATARES_PIEZA_REQUESTED:
      return {
        ...state,
        bibliotecasAvataresPiezas: { ...state.bibliotecasAvataresPiezas, loading: true },
      }
    case actions.DELETE_BIBAVATARES_PIEZA_SUCCEEDED:
      return {
        ...state,
        bibliotecasAvataresPiezas: {
          ...state.bibliotecasAvataresPiezas,
          loading: false,
          data: state.bibliotecasAvataresPiezas.data.filter(size => size.id !== action.payload),
        },
      }
    case actions.DELETE_BIBAVATARES_PIEZA_FAILED:
      return {
        ...state,
        bibliotecasAvataresPiezas: {
          ...state.bibliotecasAvataresPiezas,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
